import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an API icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AwesomeIcon width={12} />
 */
const AwesomeIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M15.22 12.915L11.64 14.645L9.91 18.225C9.41 19.265 8.59 19.265 8.09 18.225L6.36
            14.645L2.78 12.915C1.74 12.415 1.74 11.595 2.78 11.095L6.36 9.365L8.09 5.785C8.59 4.745
            9.41 4.745 9.91 5.785L11.64 9.365L15.22 11.095C16.26 11.595 16.26 12.415 15.22 12.915ZM21.68
            4.615L20.15 3.845L19.38 2.315C19.17 1.895 18.82 1.895 18.61 2.315L17.84 3.845L16.31 4.615C15.89
            4.825 15.89 5.175 16.31 5.385L17.84 6.155L18.61 7.685C18.82 8.105 19.17 8.105 19.38 7.685L20.15
            6.155L21.68 5.385C22.11 5.175 22.11 4.835 21.68 4.615ZM21.68 18.615L20.15 17.845L19.38
            16.315C19.17 15.895 18.82 15.895 18.61 16.315L17.84 17.845L16.31 18.615C15.89 18.825 15.89
            19.175 16.31 19.385L17.84 20.155L18.61 21.685C18.82 22.105 19.17 22.105 19.38 21.685L20.15
            20.155L21.68 19.385C22.11 19.175 22.11 18.835 21.68 18.615Z`}
        />
    </SvgIcon>
)

AwesomeIcon.defaultProps = defaultProps

export { AwesomeIcon }
